module.exports = __webpack_public_path__ + "static/img/warn.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warn.png
// module id = LkBP
// module chunks = 14